// extracted by mini-css-extract-plugin
var _1 = "#007ac9";
var _2 = "comparableRow-Qlef";
var _3 = "#575757";
var _4 = "differencesContainer-aDHu";
var _5 = "equalValues-WOSC";
var _6 = "1.5rem";
var _7 = "firstSubTopicContainer-qk9B";
var _8 = "label-zwBg";
var _9 = "leftValue-XGty";
var _a = "leftValueContainer-pMdO";
var _b = "#dedede";
var _c = "#adf";
var _d = "1rem";
var _e = "#bebebe";
var _f = "noResults -qHVs";
var _10 = "rightValue-NKvb";
var _11 = "rightValueContainer-SCao";
var _12 = "routePathComparisonContainer-gRhO";
var _13 = ".8rem";
var _14 = "subTopic-Pm7X";
var _15 = "toggleButton-xeym";
var _16 = "toggleButtonContainer-g0QU";
var _17 = "#000";
var _18 = "valueChanged-zANc";
var _19 = "valueContainer-xoJb";
var _1a = "values-xZQw";
export { _1 as "busBlue", _2 as "comparableRow", _3 as "darkGrey", _4 as "differencesContainer", _5 as "equalValues", _6 as "extraLargeFontSize", _7 as "firstSubTopicContainer", _8 as "label", _9 as "leftValue", _a as "leftValueContainer", _b as "lightGrey", _c as "lightblue", _d as "mediumFontSize", _e as "mediumLightGrey", _f as "noResults", _10 as "rightValue", _11 as "rightValueContainer", _12 as "routePathComparisonContainer", _13 as "smallFontSize", _14 as "subTopic", _15 as "toggleButton", _16 as "toggleButtonContainer", _17 as "unusedNodeColor", _18 as "valueChanged", _19 as "valueContainer", _1a as "values" }
